import { render, staticRenderFns } from "./UserKpiPanel.vue?vue&type=template&id=2c10ceff&scoped=true&"
import script from "./UserKpiPanel.vue?vue&type=script&lang=js&"
export * from "./UserKpiPanel.vue?vue&type=script&lang=js&"
import style0 from "./UserKpiPanel.vue?vue&type=style&index=0&id=2c10ceff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c10ceff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDivider,VIcon,VNavigationDrawer,VSkeletonLoader,VSpacer})
